<template>
  <v-data-table ref="dataTable"
                id="data-table"
                :headers="headers"
                hide-default-footer
                :items="templates"
                :items-per-page="-1"
                :loading="loading"
                dense
                no-data-text="There are no templates here."
                v-resize="resizeWindow"
                :fixed-header="fixedHeader"
                :height="tableHeight"
                class="">
    <template v-slot:item.edit="{item: template}">
      <ShareTemplateMenu :template="template">
      </ShareTemplateMenu>
    </template>
    <template v-slot:item.slug="{item: template}">
      {{ template.name }}
    </template>
    <template v-slot:item.is_featured="{item: template}">
      {{ template.is_featured ? 'Yes' : 'No' }}
    </template>
    <template v-slot:item.is_active_released_not_expired="{item: template}">
      {{ template.is_active_released_not_expired ? 'Yes' : 'No' }}
    </template>
    <template v-slot:item.is_default="{item: template}">
      {{ template.is_default ? 'Yes' : 'No' }}
    </template>
    <template v-slot:item.is_editable="{item: template}">
      {{ template.is_editable ? 'Yes' : 'No' }}
    </template>
    <template v-slot:item.can_share_links="{item: template}">
      {{ template.can_share_links ? 'Yes' : 'No' }}
    </template>
    <template v-slot:item.has_either_link_tag="{item: template}">
      {{ template.has_either_link_tag ? 'Yes' : 'No' }}
    </template>
    <template v-slot:item.can_be_selected="{item: template}">
      {{ template.can_be_selected ? 'Yes' : 'No' }}
    </template>
    <template v-slot:item.is_quick_share="{item: template}">
      {{ template.is_quick_share ? 'Yes' : 'No' }}
    </template>
    <template v-slot:item.is_campaign="{item: template}">
      {{ template.is_campaign ? 'Yes' : 'No' }}
    </template>
    <template v-slot:item.groups="{item:template}">
      <v-tooltip v-if="template.groups.length"
                 top>
        <template v-slot:activator="{on, attrs}">
          <div v-bind="attrs"
               v-on="on">
            Yes
          </div>
        </template>
        <div>
          <div v-for="group in template.groups"
               :key="group.id">
            {{ group.name }}
          </div>
        </div>
      </v-tooltip>
      <template v-else>
        No
      </template>
    </template>
    <template v-slot:item.user="{item:template}">
      <template v-if="template.user">
        {{ template.user.name }}
      </template>
    </template>
    <template v-slot:item.release_at="{item: template}">
      <template v-if="template.release_at">
        {{ template.release_at | datetime('MMM D, YYYY') }}
      </template>
    </template>
    <template v-slot:item.expires_at="{item: template}">
      <template v-if="template.expires_at">
        {{ template.expires_at | datetime('MMM D, YYYY') }}
      </template>
    </template>
    <template v-slot:item.metrics.delivered_count="{item: template}">
      {{ template.metrics.delivered_count | number }}
    </template>
    <template v-slot:item.metrics.delivered_rate="{item: template}">
      {{ (template.metrics.delivered_rate * 100) | number(1) }}%
    </template>
    <template v-slot:item.metrics.unique_open_count="{item: template}">
      {{ template.metrics.unique_open_count | number }}
    </template>
    <template v-slot:item.metrics.unique_click_count="{item: template}">
      {{ template.metrics.unique_click_count | number }}
    </template>
    <template v-slot:item.metrics.click_rate="{item: template}">
      {{ (template.metrics.click_rate * 100) | number(1) }}%
    </template>
    <template v-slot:item.metrics.unique_failed_count="{item: template}">
      {{ template.metrics.unique_failed_count | number }}
    </template>
    <template v-slot:item.metrics.failed_rate="{item: template}">
      {{ (template.metrics.failed_rate * 100) | number(1) }}%
    </template>
    <template v-slot:item.platforms="{item: template}">
      <ul style="margin: 0; padding: 0; list-style-type: none;"
          v-if="template.is_web || template.is_app || template.is_gmail || template.is_outlook">
        <li v-if="template.is_app">
          Apps
        </li>
        <li v-if="template.is_gmail">
          Gmail
        </li>
        <li v-if="template.is_outlook">
          Outlook
        </li>
        <li v-if="template.is_web">
          Website
        </li>
      </ul>
    </template>
    <template v-slot:item.created_at="{item: template}">
      {{ template.created_at | datetime }}
    </template>
    <template v-slot:item.updated_at="{item: template}">
      {{ template.updated_at | datetime }}
    </template>
  </v-data-table>
</template>
<style lang="scss">
.Column__Name {
  max-width: 300px;
}
</style>
<script>
import {mapGetters} from 'vuex';
import ShareTemplateMenu from './ShareTemplateMenu';

export default {
  components: {ShareTemplateMenu},
  props: {
    fixedHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    templates: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // MLD-6458
      resizing: false,
      initialX: 0,
      currentHeader: null,
      currentHeaderElement: null,
      tableHeight: '500px',
      headers: [],
    }
  },
  computed: {
    ...mapGetters([
      'isCampaignsEnabled', // MLD-3917
      'isEngagementScoreEnabled', // MLD-5226
      'isQuickShareEnabled', // MLD-3917
      'team',
    ]),
    templateCount() {
      return this.templates.length;
    },
    defaultHeaders() {
      let headers = [
        {
          text: '',
          value: 'edit',
          sortable: false,
        },
        {
          text: 'Name',
          value: 'slug',
          width: '400px',
          //cellClass: 'Column__Name text-truncate',
        },
        { // MLD-3808
          text: 'Subject',
          value: 'subject',
          width: '400px',
          //cellClass: 'Column__Name text-truncate',
        },
        { // MLD-6517
          text: 'Subject lines',
          value: 'subject_lines_count',
        },
        {
          text: 'Asset ID',
          value: 'asset_id',
          cellClass: 'text-nowrap',
        },
        { // MLD-4796
          text: 'Brand',
          value: 'brand.name',
          cellClass: 'text-nowrap',
        },
        {
          text: 'Active',
          value: 'is_active_released_not_expired',
        },
        { // MLD-2846
          text: 'Featured',
          value: 'is_featured',
        },
        { // MLD-2910
          text: 'Editor',
          value: 'editor_name',
        },
        { // MLD-5385
          text: 'Language',
          value: 'locale_name',
          cellClass: 'text-nowrap',
        },
        {
          text: 'Engagement Score',
          value: 'metrics.engagement_score',
          align: 'end',
          cellClass: 'text-end',
        },
        {
          text: 'Delivered',
          value: 'metrics.delivered_count',
          align: 'end',
          cellClass: 'text-end',
        },
        { // MLD-4598
          text: 'Delivered Rate',
          value: 'metrics.delivered_rate',
          align: 'end',
          cellClass: 'text-end',
        },
        {
          text: 'Opened',
          value: 'metrics.unique_open_count',
          align: 'end',
          cellClass: 'text-end',
        },
        {
          text: 'Clicked',
          value: 'metrics.unique_click_count',
          align: 'end',
          cellClass: 'text-end',
        },
        { // MLD-4598
          text: 'CTR',
          value: 'metrics.click_rate',
          align: 'end',
          cellClass: 'text-end',
        },
        {
          text: 'Failed',
          value: 'metrics.unique_failed_count',
          align: 'end',
          cellClass: 'text-end',
        },
        { // MLD-4598
          text: 'Failed Rate',
          value: 'metrics.failed_rate',
          align: 'end',
          cellClass: 'text-end',
        },
        {
          text: 'Release',
          value: 'release_at',
          cellClass: 'text-nowrap',
        },
        {
          text: 'Expires',
          value: 'expires_at',
          cellClass: 'text-nowrap',
        },
        {
          text: 'Groups',
          value: 'groups',
          sortable: false,
        },
        {
          text: 'User',
          value: 'user',
        },
        { // MLD-4653
          text: 'Appears in list',
          value: 'can_be_selected',
        },
        {
          text: 'Is Editable',
          value: 'is_editable',
        },
        {
          text: 'Can Share Links',
          value: 'can_share_links',
        },
        {
          text: 'Has Share Tags',
          value: 'has_either_link_tag',
        },
        {
          text: 'Use in Campaigns',
          value: 'is_campaign',
        },
        {
          text: 'Is Quick-Share',
          value: 'is_quick_share',
        },
        {
          text: 'Is Default Quick-Share',
          value: 'is_default',
        },
        { // MLD-4705
          text: 'Created',
          value: 'created_at',
          cellClass: 'text-nowrap',
        },
        { // MLD-4705
          text: 'Updated',
          value: 'updated_at',
          cellClass: 'text-nowrap',
        },
      ];
      if (false === this.isCampaignsEnabled) {
        headers = headers.filter(item => !['is_campaign'].includes(item.value));
      }
      if (false === this.isEngagementScoreEnabled) { // MLD-5226
        headers = headers.filter(item => !['engagement_score'].includes(item.value));
      }
      if (false === this.isQuickShareEnabled) {
        headers = headers.filter(item => !['is_quick_share', 'is_default'].includes(item.value));
      }
      return headers;
    },
  },
  watch: {
    templates(newTemplates, oldTemplates) {
      // console.log('watch templates', newTemplates?.length, oldTemplates?.length);
      if (newTemplates.length !== oldTemplates.length) {
        this.$nextTick(() => {
          this.adjustTableHeight(newTemplates);
        });
      }
    },
  },
  async created() {
    //this.headers = await this.initHeaders();
    this.headers = this.defaultHeaders;
    this.adjustTableHeight(this.templates);
  },
  methods: {
    resizeWindow() {
      //console.log('resizeWindow');
      this.adjustTableHeight(this.templates);
    },
    adjustTableHeight(templates) {
      if (!templates) {
        templates = this.templates;
      }

      if (this.fixedHeader === false) {
        this.tableHeight = null;
        return;
      }
      const dataTableElement = document.querySelector('#data-table');
      if (dataTableElement) {
        const scrollbarHeight = 20;
        const windowHeight = window.innerHeight;
        const tableElement = document.querySelector('#data-table > .v-data-table__wrapper > table');
        const headerTop = dataTableElement.getBoundingClientRect().top;
        const maxHeight = windowHeight - headerTop - scrollbarHeight;
        const tableActualHeight = tableElement.getBoundingClientRect().height;
        const tableHeight = Math.min(maxHeight, (tableActualHeight + scrollbarHeight));
        this.tableHeight = `${tableHeight}px`;
        console.log('windowHeight=', windowHeight, 'headerTop=', headerTop, 'scrollBarHeight=', scrollbarHeight, 'tableActualHeight=', tableActualHeight);
        console.log('maxHeight=', maxHeight, 'tableHeight=', tableHeight);
      } else {
        //this.tableHeight = `600px`;
        this.tableHeight = null;
        console.log('tableHeight = ', this.tableHeight);
      }
    },
    /*async initHeaders() {
      return await localForage.getItem('admin_share_template_columns') ?? this.defaultHeaders;
    },
    initResize(event, header) { // MLD-6458
      this.resizing = true;
      this.initialX = event.clientX;
      this.currentHeader = header;
      this.currentHeaderElement = event.target.parentElement;
      document.addEventListener('mousemove', this.onResize);
      document.addEventListener('mouseup', this.stopResize);
    },
    onResize(event) {
      if (this.resizing && this.currentHeaderElement) {
        const deltaX = event.clientX - this.initialX;
        const minWidth = 50;
        const currentWidth = this.currentHeaderElement.clientWidth;
        const newWidth = Math.max(minWidth, currentWidth + deltaX);
        this.currentHeaderElement.style['min-width'] = `${newWidth}px`;
        this.currentHeaderElement.style['width'] = `${newWidth}px`;
        this.currentHeader.width = `${newWidth}px`;
        this.initialX = event.clientX;
      }
    },
    async stopResize() {
      this.resizing = false;
      await this.saveHeaders();
      this.initialX = 0;
      this.currentHeader = null;
      this.currentHeaderElement = null;
      document.removeEventListener('mousemove', this.onResize);
      document.removeEventListener('mouseup', this.stopResize);
      this.adjustTableHeight(this.templates);
    },
    async saveHeaders() {
      await localForage.setItem('admin_share_template_columns', defaults(this.headers));
    },*/
  }
}
</script>
